import { NodeList } from "./Collections/NodeList"
import { Node } from "./Collections/Node";



export interface ISoundSprite {
    /**
     * Cas startu ve vterinach
     */
    start: number,
    /**
     * Cas konce ve vterinach
     */
    end: number,
    /**
     * True, pokud se ma zvuk prehravat ve smycce
     */
    loop: boolean
}



export class SoundManager {
    /**
     * Seznam vsech pc.SoundComponent, ktere spravce ovlada
     */
    private static _components: NodeList<pc.SoundComponent> = new NodeList<pc.SoundComponent>();

    /**
     * True, pokud se nemaji prehravat zadne zvuky
     */
    static get mute(): boolean { return SoundManager._mute; }
    static set mute(mute: boolean) { SoundManager._mute = mute; }
    private static _mute: boolean = false;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static createSoundComponent(entity: pc.Entity, data?: any): void {
        SoundManager._components.add(entity.addComponent(pc.eCompomentType.sound, data) as pc.SoundComponent);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static addComponent(component: pc.SoundComponent): void {
        SoundManager._components.add(component);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static remComponent(component: pc.SoundComponent): void {
        SoundManager._components.every((c: pc.SoundComponent, node: Node<pc.SoundComponent>): boolean => {
            if (c == component) {
                SoundManager._components.removeByNode(node);
                return false;
            }

            return true;
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static pause(): void {
        SoundManager._components.forEach((c: pc.SoundComponent) => { c.pause(); });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static resume(): void {
        SoundManager._components.forEach((c: pc.SoundComponent) => { c.resume(); });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static stop(): void {
        SoundManager._components.forEach((c: pc.SoundComponent) => { c.stop(); });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    static playSound(entity: pc.Entity | pc.SoundComponent, slotName: string): void {
        let sound = entity instanceof pc.Entity ? entity.sound : entity;

        if (!SoundManager._mute)
            sound.play(slotName);
    }

    //-------------------------------------------------------------------------
    /**
     * Vytvori pc.SoundSlot v zadane pc.Entity. Entity musi mit pc.SoundComponent
     * @param component Componenta, do ktere chceme pridat slot
     * @param spriteName Jmeno slotu
     * @param sprite Data audio spritu
     * @param assetId Index assetu
     */
    //-------------------------------------------------------------------------
    static addSoundSlot(entity: pc.Entity, slotName: string, sprite: ISoundSprite, assetId: number): pc.SoundSlot {
        return entity.sound.addSlot(slotName, {
            asset: assetId,
            loop: sprite.loop,
            startTime: sprite.start,
            duration: sprite.end - sprite.start
        });
    }
}